/**
 * Create collapsible elements. Supports checkboxes as collapse initiators
 *
 * @example
 * By default, checking checkbox will reveal collapsible (hidden class is removed from collapse target)
 * <input type="checkbox" class="js-collapsible" data-collapse=".js-collapse-target">
 * <div class="js-collapse-target hidden">
 *   Content to be shown
 * </div>
 *
 * For reversed collapsible visibility, add 'data-collapse-if-checked' for the trigger
 * <input type="checkbox" class="js-collapsible" data-collapse=".js-collapse-target" data-collapse-if-checked>
 * <div class="js-collapse-target">
 *   Content to be hidden
 * </div>
 */

const HIDE_CLASS = 'hidden';

/**
 * Toggle collapsible
 *
 * @private
 * @param {NodeList} elements Nodelist of elements
 * @param {boolean} shown Toggle visibility
 */
function toggleCollapsible(elements, shown) {
  elements.forEach(el => {
    if(shown) {
      el.classList.remove(HIDE_CLASS)
    } else {
      el.classList.add(HIDE_CLASS);
    }
  })
}

/**
 * Initialize collapsible
 *
 * @private
 * @param {HTMLElement} triggerEl Trigger element
 */
function initializeCollapsible(triggerEl) {
  const data = {
    tagName: triggerEl.tagName.toLowerCase(),
    type: null,
    targetElements: null,
  };

  // Type for inputs
  if(data.tagName === 'input') {
    data.type = triggerEl.type;
  }

  const targetSelector = triggerEl.getAttribute('data-collapsible');

  if(!targetSelector) {
    console.warn('No collapse target defined for', triggerEl);
  }

  data.targetElements = document.querySelectorAll(targetSelector);

  if(data.targetElements.length === 0) {
    return;
  }

  if(data.type === 'checkbox') {
    //if defined, collapsible visibility should be reversed
    const collapseWhenChecked = !!(triggerEl.getAttribute('data-collapse-if-checked'));

    // Initial status
    const show = collapseWhenChecked ? triggerEl.checked : !triggerEl.checked;
    toggleCollapsible(data.targetElements, show);

    triggerEl.addEventListener('change', () => {
      const show = collapseWhenChecked ? triggerEl.checked : !triggerEl.checked;
      toggleCollapsible(data.targetElements, show);
    });
  }
}

const triggers = document.getElementsByClassName('js-collapsible');

triggers.forEach(triggerEl => {
  initializeCollapsible(triggerEl);
})
